<template>
    <div class="carousel-slide w-full flex-shrink-0">
        <slot />
    </div>
</template>
